<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-cover">
<h1>About the Cover</h1>
<p>The mention of spending time in a French villa brings to mind so many intriguing thoughts – of white plaster-covered villa walls, grape vines climbing on a trellis outside a lace-curtained window, glasses of red wine being consumed on a sunny afternoon in a pretty garden, eating slices of bread smothered in lashings of olive butter. The images go on and on in one’s mind and one is tempted to say “Damn it – I want to do it – I want to live in a French villa and experience life at its best – even if it can only be for the limit of three months”. This is how we felt, so we started from scratch, knowing nothing of rural France, except that we wanted a villa in a centuries-old town. It was just the most wonderful three months of our lives. As we could not speak French, it was a difficulty, as no French person in Aubusson could speak English. But what fun it was trying to be understood!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?9ab2f260